document.addEventListener("DOMContentLoaded", function (event) {
  var el = document.getElementById('carouselFrontpage');

  if (el) {
    function fade() {
      if (document.documentElement.clientWidth > 768) {
        el.classList.add("carousel-fade");
      } else {
        el.classList.remove("carousel-fade");
      }
    }

    fade();
    window.onresize = fade;
  }
});
